// extracted by mini-css-extract-plugin
module.exports = {"calendarContainer":"ClockData_calendarContainer__11RNp","calendarButtons":"ClockData_calendarButtons__-vgsw"};